import { pxToRem } from './biomeTokens';

export const spacingTheme = {
  1: pxToRem(1),
  2: pxToRem(2),
  4: pxToRem(4),
  8: pxToRem(8),
  10: pxToRem(10),
  12: pxToRem(12),
  16: pxToRem(16),
  20: pxToRem(20),
  24: pxToRem(24),
  28: pxToRem(28),
  32: pxToRem(32),
  36: pxToRem(36),
  40: pxToRem(40),
  44: pxToRem(44),
  48: pxToRem(48),
  52: pxToRem(52),
  56: pxToRem(56),
  60: pxToRem(60),
  76: pxToRem(76),
  80: pxToRem(80),
  92: pxToRem(92),
  96: pxToRem(96),
  100: pxToRem(100),
  120: pxToRem(120),
  132: pxToRem(132),
  152: pxToRem(152),
  240: pxToRem(240),
  300: pxToRem(300),
  320: pxToRem(320),
  400: pxToRem(400)
};
